import { TYPE_TEAMS } from '@/constants';
import { getRandomItemFromArray } from '@/utilities';
import Employee from '@/models/Employee';
import QA from '@/models/Employee/QA';
import RD from '@/models/Employee/RD';
import Room from '@/models/Room';

import DeliveryQueue from '@/mixins/DeliveryQueue';

export default class Team extends Room {
  constructor({
    x, y, width, height, type, groupManager,
  }) {
    super({
      x, y, width, height, type, groupManager,
    });
    this.taskListPending = [];
    this.taskFinishedCount = 0;

    this.addSkill(new DeliveryQueue());

    // phase 1 先直接加到最大
    this.hireEmployee();
  }

  get taskPendingCount() {
    return this.taskListPending.length;
  }

  get hasPendingTask() {
    return this.taskListPending.length > 0;
  }

  // 算法要再檢查一下
  // 根據 pending tasks 跟正在做的 tasks 的 ETA 來計算
  get workload() {
    const taskPendingETA = this.taskListPending
      .reduce((acc, task) => task.remainingTime + acc, 0);
    const taskInProgressETA = this.memberList
      .reduce((acc, employee) => {
        const workload = employee.task?.remainingTime || 0;
        return acc + workload;
      }, 0);
    return taskPendingETA + taskInProgressETA;
  }

  // phase 2 依照 tick 增加
  hireEmployee() {
    for (let i = 0; i < this.maxCapacity; i += 1) {
      let employee;

      switch (this.type) {
        case TYPE_TEAMS.RD:
          employee = new RD({ team: this, index: i });
          break;
        case TYPE_TEAMS.QA:
          employee = new QA({ team: this, index: i });
          break;
        default:
          employee = new Employee({ team: this, index: i });
          break;
      }

      this.memberList.push(employee);
    }
  }

  addTaskToDeliverList(tasks) {
    this.taskFinishedCount += 1;
    this.skills.deliveryQueue.addItems(tasks);
  }

  getPendingTask() {
    return this.taskListPending.shift();
  }

  findRandomIdleMember() {
    return getRandomItemFromArray(this.memberList.filter((m) => m.onSeat));
  }

  // 暫時由 Team 來接，應該要有個 Room 的角色
  // 如果要擴充，是人走進來要怎麼辦？
  receiveTask(tasks) {
    this.taskListPending = [...this.taskListPending, ...tasks];
  }
}
